export enum PaymentResponseStatus{
    CREATED = "CREATED",
    APPROVED = "APPROVED",
    PENDING = "PENDING",
    EXPIRED = "EXPIRED",
    ERROR = "ERROR",
    DECLINED= "DECLINED"
}